import shortHeaderStyles from 'styles/css/ShortHeaderStyles.module.scss';
import sharedStyles from 'styles/css/SharedStyles.module.scss';
import LogoBlack512 from 'styles/images/logo/logo512-black.png';
import BackIcon from 'styles/images/svg/back.svg';
import { useNavigate } from "react-router-dom";


const SimpleHeaderWithBackBtn = (props) => {

	const navigate = useNavigate();

    return (

        

        <div className={[sharedStyles.flex, sharedStyles['flex-col'], sharedStyles.itemsCenter, sharedStyles['py-xs'], sharedStyles['px-lg']].join(' ')} style={{backgroundColor: "white", borderBottom: "solid 1px #d5d5d5"}}>
	        <div className={[shortHeaderStyles['header-logo-back'], sharedStyles['w-full']].join(' ')}>
	            <img onClick={() => navigate(-1)} className={shortHeaderStyles['back-btn']} src={BackIcon} width={18} height={18}  />
	            <img src={LogoBlack512} alt="logo" className={shortHeaderStyles.logo} />
	            <span className={shortHeaderStyles['hide-like-back-btn']} />
	        </div>
        </div>

    );
}

export default SimpleHeaderWithBackBtn;
